module.exports = __webpack_public_path__ + "img/warning-light.92225c78.svg";